import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, SwiperDirective } from '@pro-connect/shared';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-pro-exp-experts-slider',
  templateUrl: './pro-exp-experts-slider.component.html',
  styleUrls: ['./pro-exp-experts-slider.component.scss'],
  imports: [CommonModule, RouterModule, AnimateModule, SwiperDirective],
})
export class ProExpExpertsSliderComponent {
  public readonly swiperConfig: SwiperOptions = {
    centeredSlides: false,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    effect: 'coverflow',
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: '.app-pro-exp-exp__cont__swi__nav--pag',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.app-pro-exp-exp__cont__swi__nav--next',
      prevEl: '.app-pro-exp-exp__cont__swi__nav--prev',
    },
  };
}
